module.exports = __webpack_public_path__ + "img/app-download-apple.6decd6e0.svg";